<template lang="pug">
    .map-app
        .row.map-app__header-mobile-row
            header.map-app__header-mobile.d-block.d-md-none.col-md-12
                a(:href="backUrl").map-app__header__breadcrumb
                    i.icon-back 
                    h2 
                        //- img(src="../static/chevron-left-dark.svg").chevron-left.chevron-left__dark
                        ChevronLeftDark.chevron-left.chevron-left__dark
                        | {{ title }}
                ul.map-app__header-mobile-tabs
                    li
                        button(
                            @click="tabClicked('map')"
                            :class="listIsActive ? '': 'active'"
                        ) Map view
                    li 
                        button(
                            @click="tabClicked('list')"
                            :class="listIsActive ? 'active': ''"
                        ) List view
            
        .row.map-app__main-view
            .map-app__map-view.col-md-8.col-12.p-0
                MapView(
                    :data = "data"
                )
            .map-app__info-col.col-md-4.col-12.p-0(v-if="listIsActive")
                .map-app__info-col-container
                    header.map-app__header.d-none.d-md-block
                        p: a(:href="backUrl").map-app__header__breadcrumb
                            //- img(src="../static/chevron-left.svg").chevron-left
                            ChevronLeft.chevron-left
                            | Back to itineraries
                        h2 {{ title }}

                    Tabs
                    transition
                        router-view(
                            :data = "data"
                        )
</template>

<script>
import MapView from './mapView.vue'
import Tabs from './mapTabs.vue'
import Highlights from './mapHighlights.vue'
import ChevronLeft from '../static/chevron-left.svg'
import ChevronLeftDark from '../static/chevron-left-dark.svg'

export default {
    props: ['data'],
    data() {
        return {
            title: '',
            listIsActive: true,
            deviceIsMobileWidth: null,
            backUrl: '/see-do/itineraries',
        }
    },
    mounted() {
        // console.log('mapApp this.data', this.data)
        this.title = this.data.title
        // console.log('isWidthMobile: ', this.isWidthMobile())
        this.windowResizeHandler()
        window.addEventListener('resize', this.windowResizeHandler)
    },
    methods: {
        tabClicked(name) {
            this.listIsActive = name == 'list' ? true : false
        },
        isWidthMobile() {
            return window.matchMedia('(max-width: 767px)').matches
        },
        windowResizeHandler() {
            // console.log('windowResizeHandler', ' isWidthMobile: ', this.isWidthMobile())
            this.deviceIsMobileWidth = this.isWidthMobile()
        }
    },
    watch: {
        deviceIsMobileWidth() {
            // console.log('deviceIsMobileWidth', this.deviceIsMobileWidth)
            if(!this.deviceIsMobileWidth) this.listIsActive = true
        }
    },
    components: {
        Tabs,
        Highlights,
        MapView,
        ChevronLeft,
        ChevronLeftDark,
    }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap-grid";
@import "../scss/variables";

.slide-enter-active, .slide-leave-active{
    transition: opacity 0.187s, transform 0.187s;
}

.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
    transform: translateX(25%);
    opacity: 0;
}
.map-app {
    $self: &;
    font-family: 'open_sansregular';
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    height: 100%;
    font-size: 16px;
    font-weight: normal;

    .chevron-left {
        position: relative;
        top: -1px;
        width: 12px;
        height: 12px;
        margin-right: 5px;

        &__dark {
            color: $white;
            width: 20px;
            height: 20px;
        }
    }

    .row {
        height: 100%;
        margin: 0;

        &.map-app__header-mobile-row {
            height: auto;
        }
    }

    ul {
        list-style: none;
    }
    
    h2 {
        margin: 0;
        font-family: 'open_sansregular';
        font-size: 16px;
    }

    .icon-back{
        &::after {
            font-family: 'icomoon';
            content: '';
        }
    }

    &__main-view.row {
        position: relative;
        height: 83%;

        @media (min-width: 767px) {
            height: 100%;
        }
    }

    &__map-view {
        height: 100%;
        background-color: #efefef;
    }

    &__info-col.col-12 {
        position: absolute;
        height: 100%;
        background: $white;
        right: 0;
        // overflow: auto;
    }

    &__info-col-container {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
    }

    .row.map-app__header-mobile-row {
        height: 17%;

        @media (min-width: 767px) {
            height: 0;
        }
    }

    &__header { 
        display: flex;
        flex-direction: column;
        padding: 2rem;
        flex: 0 1 auto;

        & > * + * {
            margin-bottom: 2rem;
        }

        &__breadcrumb {
            font-size: 14px;
            line-height: 20px;
            font-style: normal;
            font-weight: normal;
        }

        &.col-12 {
            padding: 2rem;
        }

        h2 {
            font-family: 'open_sansbold', Arial;
            font-size: 26px;
            line-height: 32px;
        }

        &-mobile {
            background: $darkBg;
            padding: 0;
            margin: 0;

            h1, h2, h3, h4, p {
                color: $white;
                font-size: 1.25rem;
                padding: 1rem 0 1rem 1rem;
            }

            &-tabs {
                display: flex;
                flex-direction: row;
                padding: 1rem;
                padding-top: 0;

                > li {
                    width: 50%;

                    button {
                        display: flex;
                        width: 100%;
                        align-items: center;
                        justify-content: center;
                        border-radius: 5px;
                        border: none;
                        color: $white;
                        background: $darkBg2;

                        &.active {
                            background: $red;
                            border-radius: 5px;
                        }

                        &:focus {
                            outline: none;
                        }
                    }
                }
            }
        }
    }
}
</style>